module.exports = __webpack_public_path__ + "img/icn_telephone.83f0ca59.svg";